import { Component, input, computed, ChangeDetectionStrategy, ViewEncapsulation } from "@angular/core";
import { CommonModule } from "@angular/common";
import { cn } from "../utils/utils";

@Component({
  selector: "div[agentChatUserMessageToolbar]",
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  template: `<ng-content></ng-content>`,
  host: {
    "[class]": "computedClass()",
  },
})
export class AgentChatUserMessageToolbar {
  readonly inputClass = input<string | undefined>();

  readonly computedClass = computed(() => cn("achat-user-toolbar", this.inputClass()));
}
